// extracted by mini-css-extract-plugin
export default {"searchInput":"styles_searchInput__lFUhl","searchIcon":"styles_searchIcon__0HUvJ","input":"styles_input__skIPr"};